<template>
  <div class="flex justify-center items-center">
    <div
      :class="{
        'border-4 w-5 h-5': (size === 'sm'),
        'border-4 w-10 h-10': (size === 'md'),
        'border-8 w-20 h-20': (size === 'lg'),
      }"
      class="spinner-border animate-spin inline-block border-white border-opacity-20 rounded-full bg-transparent"
      :style="{ 'border-top-color': color }"
      role="status"
    />
  </div>
</template>

<script>
export default {
  name: "TwSpinner",
  props: {
    size: {
      type: String,
      default: "md",
      validator(value) {
        return ["sm", "md", "lg"].includes(value)
      }
    },
    color: {
      type: String,
      default: "white"
    }
  },
  computed: {
    disableButton() {
      return this.disabled || this.loading;
    }
  }
}

// TODO: Test package/bundle size with and without css included for each component
</script>